export default {
  // 检查是否支持SessionStorage
  support_storage: function () {
    var mod = 'sm.router.storage.ability'
    try {
      window.sessionStorage.setItem(mod, mod)
      window.sessionStorage.removeItem(mod)
      return true
    } catch (e) {
      return false
    }
  },
  // 设置SessionStorage
  session_set: function (key, value) {
    window.sessionStorage.setItem(key, value)
  },
  // 读取SessionStorage
  session_get: function (key) {
    return window.sessionStorage.getItem(key)
  },
  // 移除SessionStorage
  session_remove: function (key) {
    window.sessionStorage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/components/cache/index.js